import { Ripple } from "primereact/ripple";
import { useState, MouseEvent, useRef } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export default function Privacy() {
  const [mobileMenuVisible, setMobileMenuVisible] = useState<boolean>(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState<boolean>(false);
  const [productsMenuVisible, setProductsMenuVisible] =
    useState<boolean>(false);
  const menuButtonRef = useRef<HTMLButtonElement>(null);
  const mobileMenuRef = useRef<HTMLDivElement>(null);

  const handleSmoothScroll = (
    event: MouseEvent<HTMLAnchorElement>,
    sectionId: string
  ) => {
    event.preventDefault();
    const section = document.querySelector(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
    setMobileMenuVisible(false);
    setIsDropdownVisible(false);
    setProductsMenuVisible(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuVisible(!mobileMenuVisible);
    setIsDropdownVisible(false);
  };
  return (
    <>
      <div
        className="surface py-3 px-5 shadow-2 flex align-items-center justify-content-between fixed top-0 w-full z-50"
        style={{
          zIndex: "999",
          backgroundColor: "#115c9f",
        }}
      >
        <Link to="/" state={{ scrollToId: 'home' }} id="home">
          <img
            src="/images/Navbar/fixLogo.png"
            alt="Image"
            style={{ height: "40px" }}
          />
        </Link>

        {/* Mobile menu button */}
        

        <div
          ref={mobileMenuRef}
          className={`align-items-center flex-grow-1 justify-content-between ${
            mobileMenuVisible ? "flex" : "hidden"
          } lg:flex absolute lg:static surface left-0 top-100 z-5 shadow-2 lg:shadow-none navs`}
          style={{ backgroundColor: "#115c9f" }}
        ></div>
      </div>

      <div
        className=""
        style={{
          color: "#115c9f",
          marginTop: "120px",
          fontFamily: "Poppins",
          fontWeight: "bold",
          fontSize: "20px",
          padding: "20px",
        }}
      >
        <h1 style={{ fontSize: "24px", fontWeight: "bold" }}>Privacy Policy</h1>
      </div>

      <div className="" style={{ fontFamily: "Poppins", padding: "20px" }}>
        <div
          className=""
          style={{
            backgroundColor: "#f5f5f5",
            padding: "20px",
            borderRadius: "4px",
          }}
        >
          <p style={{ fontSize: "14px" }}>Effective Date : January 01, 2025</p>
          <p style={{ fontSize: "14px" }}>Last Updated <span style={{marginLeft:'3px'}}>:</span> May 22, 2025</p>
          <p style={{ fontSize: "14px", marginTop: "10px" }}>
            PT Enerren Technologies (“we,” “our,” or “us”) is committed to
            protecting your privacy. This Privacy Policy explains how we
            collect, use, disclose, and safeguard your information when you
            visit our website or use our services, including any software,
            applications, or tools we provide (collectively, the “Service”).
          </p>
          <p style={{ fontSize: "14px", marginTop: "10px" }}>
            By accessing or using our Service, you agree to the terms of this
            Privacy Policy.
          </p>
        </div>
      </div>
      <div className="" style={{ padding: "20px" }}>
        {/* card 1 */}
        <div className="card" style={{}}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{ backgroundColor: "#f5f5f5", fontFamily: "Poppins" }}
            >
              1. Information We Collect
            </li>
            <div style={{ padding: "20px" }}>
              <p>
                We collect different types of information in connection with the
                Service, including :
              </p>
              <p>
                {" "}
                <strong>a. Information You Provide</strong>
              </p>
              <ul>
                <li className="mt-2">
                  <strong>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Account Information :
                  </strong>{" "}
                  Name, email address, company name, billing address, and other
                  contact details.
                </li>
                <li className="mt-2">
                  <strong>
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Payment Information :
                  </strong>{" "}
                  Payment method and billing information (processed securely via
                  third-party payment processors).{" "}
                </li>
                <li className="mt-2">
                  <strong>
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Support Information:
                  </strong>
                  Records of communications with our support team.
                </li>
              </ul>
              <p className="mt-4">
                {" "}
                <strong>b. Information We Automatically Collect</strong>
              </p>
              <ul>
                <li className="mt-2">
                  <strong>
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Usage Data :
                  </strong>{" "}
                  Pages visited, features used, time spent, clicks, and
                  interaction data.
                </li>
                <li className="mt-2">
                  <strong>
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Device Information :
                  </strong>{" "}
                  IP address, browser type, operating system, and device
                  identifiers.
                </li>
                <li className="mt-2">
                  <strong>
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Cookies and Tracking Technologies :
                  </strong>{" "}
                  We use cookies and similar technologies to enhance your
                  experience. You can control cookies through your browser
                  settings.
                </li>
              </ul>
            </div>
          </ul>
        </div>
        {/* card 2 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{ backgroundColor: "#f5f5f5", fontFamily: "Poppins" }}
            >
              2. How We Use Your Information
            </li>
            <div style={{ padding: "20px" }}>
              <p>We use the information we collect to :</p>
              <ul>
                <li className="mt-2">
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Provide, operate, and maintain the Service;
                </li>
                <li className="mt-2">
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Improve, personalize, and expand the Service;
                </li>
                <li className="mt-2">
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Communicate with you, including sending service updates and
                  promotional materials;
                </li>
                <li className="mt-2">
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Process transactions and manage your account;
                </li>
                <li className="mt-2">
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Monitor and analyze usage and trends;
                </li>
                <li className="mt-2">
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Detect and prevent fraud, abuse, or security issues;
                </li>
                <li className="mt-2">
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Comply with legal obligations.
                </li>
              </ul>
            </div>
          </ul>
        </div>
        {/* card 3 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{ backgroundColor: "#f5f5f5", fontFamily: "Poppins" }}
            >
              3. Sharing of Your Information
            </li>
            <div style={{ padding: "20px" }}>
              <p>
                We do not sell your personal information. We may share your
                information in the following situations :
              </p>
              <ul>
                <li className="mt-2">
                  <strong>
                    {" "}
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Service Providers :
                  </strong>{" "}
                  With third-party vendors who help us operate and maintain our
                  Service (e.g., payment processors, hosting providers).
                </li>
                <li className="mt-2">
                  <strong>
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Legal Requirements :
                  </strong>{" "}
                  When required to comply with a legal obligation or protect our
                  legal rights.{" "}
                </li>
                <li className="mt-2">
                  <strong>
                    <FontAwesomeIcon
                      icon={faCircle}
                      fontSize="10px"
                      className="mr-3"
                    />
                    Business Transfers :
                  </strong>
                  In the event of a merger, acquisition, or sale of assets.
                </li>
              </ul>
            </div>
          </ul>
        </div>
        {/* card 4 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{ backgroundColor: "#f5f5f5", fontFamily: "Poppins" }}
            >
              4. Data Retention
            </li>
            <div style={{ padding: "20px" }}>
              <p>
                We retain your personal data only as long as necessary for the
                purposes outlined in this policy, unless a longer retention
                period is required or permitted by law.
              </p>
            </div>
          </ul>
        </div>
        {/* card 5 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{ backgroundColor: "#f5f5f5", fontFamily: "Poppins" }}
            >
              5. Your Rights and Choices
            </li>
            <div style={{ padding: "20px" }}>
              <p>
                Depending on your jurisdiction, you may have the following
                rights :
              </p>
              <ul>
                <li className="mt-2">
                  {" "}
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Access and obtain a copy of your personal data;
                </li>
                <li className="mt-2">
                  {" "}
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Request correction or deletion of your data;
                </li>
                <li className="mt-2">
                  {" "}
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Object to or restrict the processing of your data;
                </li>
                <li className="mt-2">
                  {" "}
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Withdraw consent at any time (if processing is based on
                  consent);
                </li>
                <li className="mt-2">
                  {" "}
                  <FontAwesomeIcon
                    icon={faCircle}
                    fontSize="10px"
                    className="mr-3"
                  />
                  Lodge a complaint with a data protection authority.
                </li>
              </ul>
              <p className="mt-3">
                To exercise any of these rights, please contact us at{" "}
                <strong>support@enerren.com. </strong>
              </p>
            </div>
          </ul>
        </div>
        {/* card 6 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{ backgroundColor: "#f5f5f5", fontFamily: "Poppins" }}
            >
              6. Data Security
            </li>
            <div style={{ padding: "20px" }}>
              <p>
                We implement appropriate technical and organizational measures
                to protect your information against unauthorized access,
                disclosure, alteration, or destruction.
              </p>
            </div>
          </ul>
        </div>
        {/* card 7 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{ backgroundColor: "#f5f5f5", fontFamily: "Poppins" }}
            >
              7. International Transfers
            </li>
            <div style={{ padding: "20px" }}>
              <p>
                Your information may be transferred to, and maintained on,
                servers located outside of your jurisdiction. If you are located
                in the European Economic Area (EEA), we ensure adequate data
                protection through standard contractual clauses or other
                mechanisms.
              </p>
            </div>
          </ul>
        </div>
        {/* card 8 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{ backgroundColor: "#f5f5f5", fontFamily: "Poppins" }}
            >
              8. Children’s Privacy
            </li>
            <div style={{ padding: "20px" }}>
              <p>
                Our Service is not intended for use by individuals under the age
                of 13 (or the minimum legal age in your jurisdiction). We do not
                knowingly collect personal data from children.
              </p>
            </div>
          </ul>
        </div>
        {/* card 9 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{ backgroundColor: "#f5f5f5", fontFamily: "Poppins" }}
            >
              9. Third-Party Links
            </li>
            <div style={{ padding: "20px" }}>
              <p>
                Our Service may contain links to third-party websites. We are
                not responsible for the privacy practices of these third
                parties. We encourage you to read their privacy policies.
              </p>
            </div>
          </ul>
        </div>
        {/* card 10 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{ backgroundColor: "#f5f5f5", fontFamily: "Poppins" }}
            >
              10. Changes to This Privacy Policy
            </li>
            <div style={{ padding: "20px" }}>
              <p>
                We may update this Privacy Policy from time to time. We will
                notify you of changes by posting the updated policy on this page
                with the revised date.
              </p>
            </div>
          </ul>
        </div>
        {/* card 11 */}
        <div className="card" style={{ marginTop: "30px" }}>
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item"
              style={{ backgroundColor: "#f5f5f5", fontFamily: "Poppins" }}
            >
              11. Contact Us
            </li>
            <div style={{ padding: "20px" }}>
              <p>
                If you have any questions about this Privacy Policy, please
                contact us at:
              </p>
              <p className="ms-3">
                <strong>PT Enerren Technologies</strong>
                <br />
                Gedung Graha Inti Fauzi Lt 8 <br />
                Jl. Buncit Raya No 22 <br />
                Jakarta <br />
                Selatan <br />
                Email : <strong>support@enerren.com </strong>
              </p>
            </div>
          </ul>
        </div>
      </div>
    </>
    // content privacy
  );
}
